<template>
  <b-field>
    <b-checkbox-button v-model="dowGroup"
                       native-value="1"
    >Mon
    </b-checkbox-button>
    <b-checkbox-button v-model="dowGroup"
                       native-value="2"
    >Tue
    </b-checkbox-button>
    <b-checkbox-button v-model="dowGroup"
                       native-value="3"
    >Wed
    </b-checkbox-button>
    <b-checkbox-button v-model="dowGroup"
                       native-value="4"
    >Thu
    </b-checkbox-button>
    <b-checkbox-button v-model="dowGroup"
                       native-value="5"
    >Fri
    </b-checkbox-button>
    <b-checkbox-button v-model="dowGroup"
                       native-value="6"
    >Sat
    </b-checkbox-button>
    <b-checkbox-button v-model="dowGroup"
                       native-value="7"
    >Sun
    </b-checkbox-button>
  </b-field>
</template>

<script>
  import BField from "buefy/src/components/field/Field";
  import BCheckboxButton from "buefy/src/components/checkbox/CheckboxButton";

  export default {
    components: {
      BCheckboxButton,
      BField
    },
    name: "day-of-week-picker",
    props: ['value'],
    computed: {
      dowGroup: {
        get() {
          if (!this.value) {
            return [];
          }
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      }
    }
  }
</script>

<style scoped>

</style>